import { createFileRoute, redirect } from '@tanstack/react-router'

import i18n from '@/i18n'
import { commentFilterSchema, CommentsView } from '@/modules/lessonDetails'
import { courseQueryOptions } from '@/queries/useCourse'
import { groupQueryOptions } from '@/queries/useGroup'
import { getMetaWithPageTitle } from '@/utils/get-page-title'
import { isSelectedSemesterInOptions } from '@/utils/is-selected-semester-in-options'

export const Route = createFileRoute(
  '/_auth/timetable/$courseId/$groupId/comments'
)({
  validateSearch: commentFilterSchema,
  component: CommentsView,
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ deps: { search }, context, params }) => {
    const [group, course] = await Promise.all([
      context.queryClient.ensureQueryData(groupQueryOptions(params.groupId)),
      context.queryClient.ensureQueryData(courseQueryOptions(params.courseId))
    ])

    if (
      !search.semester ||
      !isSelectedSemesterInOptions(search.semester, group.semestersOptions)
    ) {
      throw redirect({
        replace: true,
        to: '/timetable/$courseId/$groupId/comments',
        params,
        search: {
          ...search,
          semester: group.currentSemester.id
        }
      })
    }

    return course.name
  },
  head: ({ loaderData }) =>
    getMetaWithPageTitle([
      loaderData,
      i18n.t('title.comments', { ns: 'lessonDetails' })
    ])
})
